module.exports = __webpack_public_path__ + "img/step4.9eed5f5c.png";